import type { ReactNode } from 'react'

export function ModuleRoot(props: { children: ReactNode }) {
  return <div className='min-h-80 bg-stone-600 p-6'>{props.children}</div>
}
